/**
 * Environment utilities
 *
 * Uses VITE_ENV from .env to determine runtime environment.
 * Default: 'development' if not set.
 */

export function getEnvironment(): string {
  return import.meta.env.VITE_ENV || 'development';
}

export function isProduction(): boolean {
  return getEnvironment() === 'production';
}

export function isDevelopment(): boolean {
  return !isProduction();
}